@if (event) {
    <div class="card-scoreboard_stats" [class.set-game-scoreboard]="!isTennis">
        <div class="card-scoreboard_stats-values card-scoreboard_stats-values-set">
            <div class="card-scoreboard_stats-column card-scoreboard_stats-column-turn">
                @if (showSportIcon && isTennis) {
                    @for (player of [1, 2]; track player) {
                        <span class="icon" [class.serving-icon]="turn === player">
                            <vn-icon name="sports-sb-tennis" size="12" />
                        </span>
                    }
                } @else {
                    <div class="cell highlight" [class.serving-dot]="turn === 1"></div>
                    <div class="cell highlight" [class.serving-dot]="turn === 2"></div>
                }
            </div>
            @if (isTennis) {
                <div class="card-scoreboard_stats-column card-scoreboard_stats-column-points">
                    <div class="cell highlight bold">{{ score.participant1.points | msTwoDigitConverter: useTwoDigitFormat }}</div>
                    <div class="cell highlight bold">{{ score.participant2.points | msTwoDigitConverter: useTwoDigitFormat }}</div>
                </div>
            }
            @for (setIndex of setsArray; track setIndex; let i = $index) {
                <div class="card-scoreboard_stats-column card-scoreboard_stats-column-set">
                    <div class="cell" [class.highlight]="isHighlighedSet(i, 1)">{{ getSetScore(i, 1) }}</div>
                    <div class="cell" [class.highlight]="isHighlighedSet(i, 2)">{{ getSetScore(i, 2) }}</div>
                </div>
            }
        </div>
    </div>
}
